// WEBEXPERTO: permisos propios del fork evaluados en la interfaz (issue #63).
// No hay validacion equivalente en la API a proposito: se tiene que poder forzar
// respuestas y cambios de estado por esa via para correcciones e integraciones.
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { getCurrentAccount } from 'dashboard/helper/permissionsHelper';
import {
  CONVERSATION_REPLY_WITHOUT_ASSIGNMENT_PERMISSION,
  CONVERSATION_STATUS_WITHOUT_ASSIGNMENT_PERMISSION,
} from 'dashboard/constants/permissions';

export function useWebExpertoPermissions() {
  const currentUser = useMapGetter('getCurrentUser');
  const { accountId } = useAccount();

  const currentAccountUser = computed(
    () => getCurrentAccount(currentUser.value, accountId.value) || {}
  );
  const permissions = computed(
    () => currentAccountUser.value.permissions || []
  );
  const hasCustomRole = computed(
    () => !!currentAccountUser.value.custom_role_id
  );

  const isAssignedToCurrentUser = conversation =>
    !!conversation?.meta?.assignee &&
    conversation.meta.assignee.id === currentUser.value?.id;

  // Sin el permiso, solo el operador asignado puede escribir (respuesta o nota privada).
  // Usuarios sin custom_role conservan la regla fija previa: tambien quedan bloqueados.
  const canReplyToConversation = conversation =>
    isAssignedToCurrentUser(conversation) ||
    permissions.value.includes(
      CONVERSATION_REPLY_WITHOUT_ASSIGNMENT_PERMISSION
    );

  // Sin el permiso, solo el operador asignado puede resolver, reabrir, pasar a pendiente o posponer.
  // Usuarios sin custom_role conservan el comportamiento previo: cambio de estado libre.
  const canChangeConversationStatus = conversation =>
    !hasCustomRole.value ||
    isAssignedToCurrentUser(conversation) ||
    permissions.value.includes(
      CONVERSATION_STATUS_WITHOUT_ASSIGNMENT_PERMISSION
    );

  return { canReplyToConversation, canChangeConversationStatus };
}
